var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "max-w-screen" },
    [
      _c(
        "md-card",
        [
          _c("md-card-content", { staticClass: "profile-other-container" }, [
            _c(
              "div",
              { staticClass: "container-left hidden desktop:block" },
              [
                _c("h1", [
                  _vm._v(
                    _vm._s(_vm.$t("registration-other.profil-title-generic"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "carousel",
                  {
                    attrs: {
                      "per-page": 1,
                      autoplay: true,
                      "autoplay-timeout": 6000,
                      loop: "",
                      "pagination-position": "bottom-overlay",
                      "pagination-active-color": "#23555C"
                    }
                  },
                  [
                    _vm.profilType == "pilot" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/cockpit.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-pilot-1")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "pilot" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src:
                                "/imgs/registration/other/company-executives.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-pilot-2")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "pilot" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/reseau.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-pilot-3")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "owner" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/hangar.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-owner-1")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "owner" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/roulage.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-owner-2")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "owner" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/reseau.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-owner-3")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "company" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/flotte.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-company-1")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "company" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/reseau.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-company-2")
                              )
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.profilType == "company" || _vm.profilType == "generic"
                      ? _c("slide", [
                          _c("img", {
                            attrs: {
                              src: "/imgs/registration/other/equipage.webp"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "slider-comment",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("registration-other.slide-company-3")
                              )
                            }
                          })
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container-right" }, [
              _c("h1", { staticClass: "desktop:hidden" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("registration-other.profil-title-generic")) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "desktop:hidden" },
                [
                  _c(
                    "carousel",
                    {
                      attrs: {
                        "per-page": 1,
                        autoplay: true,
                        "autoplay-timeout": 6000,
                        loop: "",
                        "pagination-position": "bottom-overlay",
                        "pagination-active-color": "#23555C"
                      }
                    },
                    [
                      _vm.profilType == "pilot" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/cockpit.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-pilot-1")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "pilot" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src:
                                  "/imgs/registration/other/company-executives.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-pilot-2")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "pilot" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/reseau.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-pilot-3")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "owner" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/hangar.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-owner-1")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "owner" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/roulage.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-owner-2")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "owner" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/reseau.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-owner-3")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "company" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/flotte.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-company-1")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "company" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/reseau.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-company-2")
                                )
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.profilType == "company" || _vm.profilType == "generic"
                        ? _c("slide", [
                            _c("img", {
                              attrs: {
                                src: "/imgs/registration/other/equipage.webp"
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "slider-comment",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("registration-other.slide-company-3")
                                )
                              }
                            })
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  ref: "form",
                  staticClass: "registration-form mt-4",
                  attrs: { action: _vm.action, method: "POST" },
                  on: {
                    submit: function($event) {
                      _vm.onSubmit($event)
                    }
                  }
                },
                [
                  _c("input", {
                    attrs: { type: "hidden", name: "_token" },
                    domProps: { value: _vm.csrkToken }
                  }),
                  _vm._v(" "),
                  _c(
                    "md-card",
                    { staticClass: "profil-form" },
                    [
                      _c("md-card-header", [
                        _c("div", { staticClass: "md-title md-title-dark" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("registration-other.profil-intro")
                              ) +
                              "\n                            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("md-card-content", [
                        _vm.profilType == "generic"
                          ? _c(
                              "div",
                              {
                                staticClass: "form-row flex",
                                staticStyle: { "flex-direction": "column" }
                              },
                              [
                                _c(
                                  "md-field",
                                  {
                                    class: {
                                      "md-invalid": !!_vm.errors["type"]
                                    }
                                  },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "registration-other.profil-offer-type"
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "md-select",
                                      {
                                        attrs: {
                                          name: "type",
                                          disabled: _vm.submitting
                                            ? "disabled"
                                            : null,
                                          required: ""
                                        },
                                        on: { "md-selected": _vm.mdSelected },
                                        model: {
                                          value: _vm.selectType,
                                          callback: function($$v) {
                                            _vm.selectType = $$v
                                          },
                                          expression: "selectType"
                                        }
                                      },
                                      [
                                        _c(
                                          "md-option",
                                          { attrs: { value: "pilot" } },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "registration-other.profil-offer-pilot"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-option",
                                          { attrs: { value: "owner" } },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "registration-other.profil-offer-plane-location"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-option",
                                          { attrs: { value: "company" } },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "registration-other.profil-offer-company"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.selectType == "pilot"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-row flex" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fData.type,
                                              expression: "fData.type"
                                            }
                                          ],
                                          attrs: {
                                            type: "hidden",
                                            value: "pilot"
                                          },
                                          domProps: { value: _vm.fData.type },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.fData,
                                                "type",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm.selectType == "owner"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-row flex" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fData.type,
                                              expression: "fData.type"
                                            }
                                          ],
                                          attrs: {
                                            type: "hidden",
                                            value: "owner"
                                          },
                                          domProps: { value: _vm.fData.type },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.fData,
                                                "type",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm.selectType == "company"
                                  ? _c(
                                      "div",
                                      { staticClass: "form-row flex" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.fData.type,
                                              expression: "fData.type"
                                            }
                                          ],
                                          attrs: {
                                            type: "hidden",
                                            value: "company"
                                          },
                                          domProps: { value: _vm.fData.type },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.fData,
                                                "type",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "md-field",
                              {
                                class: {
                                  "md-invalid": !!_vm.errors["lastname"]
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration.lastname"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    name: "lastname",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    required: "",
                                    autofocus: ""
                                  },
                                  model: {
                                    value: _vm.fData.lastname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "lastname", $$v)
                                    },
                                    expression: "fData.lastname"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors["lastname"]
                                        ? _vm.errors["lastname"][0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "md-field",
                              {
                                class: {
                                  "md-invalid": !!_vm.errors["firstname"]
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration.firstname"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    name: "firstname",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.fData.firstname,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "firstname", $$v)
                                    },
                                    expression: "fData.firstname"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors["firstname"]
                                        ? _vm.errors["firstname"][0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "md-field",
                              {
                                class: { "md-invalid": !!_vm.errors["entity"] }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration-other.entity"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    name: "entity",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.fData.entity,
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "entity", $$v)
                                    },
                                    expression: "fData.entity"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors["entity"]
                                        ? _vm.errors["entity"][0]
                                        : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c("CountrySelector", {
                              attrs: {
                                "field-class": {
                                  "md-invalid": !!_vm.errors[
                                    "entity_country_id"
                                  ]
                                },
                                errors: _vm.errors["entity_country_id"],
                                name: "entity_country_id",
                                disabled: _vm.submitting ? "disabled" : null,
                                model: _vm.fData.entity_country_id,
                                required: "",
                                "country-id": _vm.fData.entity_country_id
                              },
                              on: {
                                "on-change": function(value) {
                                  return (_vm.fData.entity_country_id = value)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "md-field",
                              {
                                class: { "md-invalid": !!_vm.errors["email"] }
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    _vm._s(_vm.$t("registration.your-email"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("md-input", {
                                  attrs: {
                                    type: "email",
                                    name: "email",
                                    disabled: _vm.submitting
                                      ? "disabled"
                                      : null,
                                    dusk: "email-input",
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.fData["email"],
                                    callback: function($$v) {
                                      _vm.$set(_vm.fData, "email", $$v)
                                    },
                                    expression: "fData['email']"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "md-error",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.errors.email
                                        ? _vm.errors.email[0]
                                        : ""
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "form-row",
                            class: { "mt-35": !!_vm.errors.email }
                          },
                          [
                            _c("phone-field", {
                              ref: "phoneInput",
                              attrs: {
                                required: "",
                                name: "phone",
                                errors: _vm.errors["phone"],
                                label: _vm.$t("registration.phone"),
                                "country-id": _vm.countryId,
                                disabled: _vm.submitting ? "disabled" : null
                              },
                              model: {
                                value: _vm.fData.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.fData, "phone", $$v)
                                },
                                expression: "fData.phone"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row" },
                          [
                            _c(
                              "md-field",
                              { class: { "md-invalid": !!_vm.errors.know } },
                              [
                                _c("label", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.$t("registration-other.find-way")
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-select",
                                  {
                                    attrs: {
                                      name: "know",
                                      dusk: "know-input",
                                      disabled: _vm.submitting
                                        ? "disabled"
                                        : null,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.fData.know,
                                      callback: function($$v) {
                                        _vm.$set(_vm.fData, "know", $$v)
                                      },
                                      expression: "fData.know"
                                    }
                                  },
                                  _vm._l(JSON.parse(_vm.findWay), function(
                                    know
                                  ) {
                                    return _c(
                                      "md-option",
                                      {
                                        key: know.id,
                                        attrs: { value: know.id }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(know.label) +
                                            "\n                                        "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "md-error" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.know ? _vm.errors.know[0] : ""
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-row form-row-submit" }, [
                          _c(
                            "div",
                            { staticClass: "form-cgu" },
                            [
                              _c("md-checkbox", {
                                attrs: {
                                  name: "cgu",
                                  id: "cgu",
                                  disabled: _vm.submitting ? "disabled" : null,
                                  dusk: "cgu-checkbox",
                                  required: ""
                                },
                                model: {
                                  value: _vm.fData["cgu"],
                                  callback: function($$v) {
                                    _vm.$set(_vm.fData, "cgu", $$v)
                                  },
                                  expression: "fData['cgu']"
                                }
                              }),
                              _vm._v(" "),
                              _c("label", {
                                attrs: { for: "cgu" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("registration-other.accept-tos")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "cgu-error" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.errors["cgu"] ? _vm.errors["cgu"] : ""
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-submit-button" },
                            [
                              _c("submit-button", {
                                staticClass: "registration-standalone-button",
                                attrs: {
                                  type: "submit",
                                  submitting: _vm.submitting,
                                  label: _vm.$t("registration.validate"),
                                  dusk: "submit-profile-button"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.onSubmit()
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66098f60", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66098f60","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration-other/ProfileComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66098f60","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration-other/ProfileComponent.vue
// module chunks = 1 2 3